import { createAsyncThunk } from "@reduxjs/toolkit";
import { ax } from "src/common/api/apiClient";
import { IApi } from "src/common/typings/app";
import {
  ICargoInsights,
  IInsightsSettings,
  IRevenueInsights,
  IVehicleInsights,
  IYardInsights,
} from "src/common/typings/insights";
// As we are using createAsynThunk, so we are writing our actions separately to provide them in extraReducers

export const getRevenueAction = createAsyncThunk(
  "insights/getRevenueAction", // action string
  async (data: IRevenueInsights) => {
    try {
      const res = await ax.post<IApi>("/get-revenue-widget", data);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getVehicleActionLevelTwo = createAsyncThunk(
  "insights/getVehicleAction/LevelTwo", // action string
  async (data: any) => {
    try {
      const res = await ax.post<IApi>("/get-vehicle-by-consignment-type", data);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getVehicleActionLevelThree = createAsyncThunk(
  "insights/getVehicleAction/LevelThree", // action string
  async (data: any) => {
    try {
      const res = await ax.post<IApi>("/get-vehicle-details-by-consignment-type", data);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getVehicleAction = createAsyncThunk(
  "insights/getVehicleAction", // action string
  async (data: IVehicleInsights) => {
    try {
      const res = await ax.post<IApi>("/get-vehicle-widget", data);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getVehicleAmountAction = createAsyncThunk(
  "insights/getVehicleAmountAction", // action string
  async (data: IVehicleInsights) => {
    try {
      const res = await ax.post<IApi>("/get-vehicle-amount-widget", data);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getCargoAction = createAsyncThunk(
  "insights/getCargoAction", // action string
  async (data: ICargoInsights) => {
    try {
      const res = await ax.post<IApi>("/get-cargo-widget", data);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getYardAction = createAsyncThunk(
  "insights/getYardAction", // action string
  async (data: IYardInsights) => {
    try {
      const res = await ax.post<IApi>("/get-yard-widget", data);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getInsightsSettings = createAsyncThunk(
  "insights/getInsightsSettings", // action string
  async () => {
    try {
      const res = await ax.get<IApi>("/get-user-section-setting");
      if (res.data.isSuccess && res.data.value) {
        return res.data.value;
      } else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const createInsightsSettings = createAsyncThunk(
  "insights/createInsightsSettings", // action string
  async (data: IInsightsSettings) => {
    try {
      const res = await ax.post<IApi>("/create-user-section-setting", data);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
